import Advice from "components/common/Advice/Advice.js";

const AchievementsContent = () => {
    return (
        <Advice
            paragraph={
                <>
                Compreender as reais necessidades de milhões de brasileiros e brasileiras faz parte do nosso compromisso. É dessa forma que encontramos soluções inovadoras, úteis e confiáveis que protegem e facilitam todas as jornadas de vida. Foi assim que, ao longo dos anos, conquistamos diversos prêmios e reconhecimentos que reforçam a nossa responsabilidade com colaboradores, clientes e parceiros, sempre em prol de uma sociedade inclusiva e sustentável.
                <br />
                <br />
                E por acreditar que <strong> nossas conquistas têm mais valor quando compartilhamos com quem caminha com a gente</strong>, apresentamos aqui as nossas premiações e reconhecimentos.
                </>
            }
        />
    );
};

export default AchievementsContent;
